import React from 'react';
import { useUserDetails } from '../helpers/UserContext';
import { Navigate } from 'react-router';
import { clearToken } from '../apis/LocalStorageApi';

export default function RequireAuth({
  adminOnly = false,
  children,
}: {
  adminOnly?: boolean;
  children: React.ReactNode;
}) {
  const [userDetails, setUserDetails, , hasAuth] = useUserDetails();
  if (!hasAuth()) {
    // Redirect to login page or show an unauthorized message
    clearToken();
    setUserDetails(null);

    return <Navigate to='/' replace />;
  }
  if (adminOnly && userDetails?.email !== 'blehr.mail@gmail.com') {
    return <Navigate to='/alpacas' replace />;
  }

  return children;
}
